import React from 'react';
import List, { defaultFilters } from '../../cruds/List';
import Edit from '../../cruds/Edit';
import { notNull, validDate, stringNotBlank } from '../../cruds/validators';
import OutputBox, { OutputBoxDate, OutputBoxContent } from '../../components/output/OutputBox';
import OutputLink from '../../components/output/OutputLink';
import { LocalizedOutputValue } from '../../components/output/OutputValue';
import InputText from '../../components/input/InputText';
import InputDate from '../../components/input/InputDate';
import CollapsibleRowList from '../../components/container/CollapsibleRow';
import RemoteInputSelect from '../../components/input/RemoteInputSelect';
import MainContainer from '../../components/MainContainer';
import { Horizontal } from '../../components/container/LayoutRow';
import { Switch, Route } from 'react-router-dom';
import { withRoles } from '../../components/container/WithRole';

const ENTITY_NAME = 'lots';
const TITLE = 'lots.title';

const CrudEdit = props => {
  const validators = [
    stringNotBlank('cas', 'lots.err.cas'),
    notNull('departmentId', 'lots.err.departmentId'),
    stringNotBlank('name', 'lots.err.name'),
    stringNotBlank('storageCabinet', 'lots.err.storageCabinet'),
    notNull('storageTemperature', 'lots.err.storageTemperature'),
    validDate('expiryDate', 'lots.err.expiryDate'),
    validDate('openingDate', 'lots.err.openingDate'),
    validDate('checkInDate', 'lots.err.checkInDate'),
  ];
  return (
    <Edit {...props}
        title={TITLE}
        entityName={ENTITY_NAME}
        entityRoute={ENTITY_NAME}
        entityId={props.match.params.number}
        validators={validators}
    >
      <InputText name="cas" label="lots.cas" required />
      <RemoteInputSelect
          from="departments"
          order="NAME"
          optionValueName="id"
          optionLabelName="name"
          name="departmentId"
          label="lots.department.id"
          required
      />
      <InputText name="name" label="lots.name" required />
      <InputText name="storageCabinet" label="lots.storageCabinet" required />
      <RemoteInputSelect
        from={ENTITY_NAME + '/storage-types'}
        optionValueName="value"
        optionLabelName="value"
        name="storageTemperature"
        label="lots.storageTemperature.name"
        localize="lots.storageTemperature"
        required
      />
      <InputDate name="expiryDate" label="lots.expiryDate" />
      <InputDate name="openingDate" label="lots.openingDate" />
      <InputText name="barcode" label="lots.barcode" />
      <InputText name="mail" label="lots.mail" />
      <RemoteInputSelect
        from={ENTITY_NAME + '/status-types'}
        optionValueName="value"
        optionLabelName="value"
        name="status"
        label="lots.status.name"
        localize="lots.status"
      />
      <InputText name="building" label="lots.building" />
      <InputText name="msds" label="lots.msds" />
      <InputDate name="checkInDate" label="lots.checkInDate" />
    </Edit>
  );
};

const CrudList = () => {
  const table = <CollapsibleRowList optionLabelName="name" hideViewButton={true} hideEditButton={!withRoles(['A', 'E'])}>
                  <Horizontal style={{ backgroundColor: '#f8fcfd' }}>
                    <OutputBox name="cas" label="lots.cas" style={{ flex: 1 }} />
                    <OutputBox name="departmentName" label="lots.department.name" style={{ flex: 1 }} />
                    <OutputBox name="name" label="lots.name" style={{ flex: 1 }} />
                    <OutputBox name="storageCabinet" label="lots.storageCabinet" style={{ flex: 3 }} />
                  </Horizontal>
                  <Horizontal style={{ backgroundColor: '#f8fcfd' }}>
                    <OutputBoxContent label="lots.storageTemperature.name" style={{ flex: 1 }}>
                      <LocalizedOutputValue name="storageTemperature" prefix="lots.storageTemperature" />
                    </OutputBoxContent>
                    <OutputBoxDate name="expiryDate" label="lots.expiryDate" style={{ flex: 1 }} />
                    <OutputBoxDate name="openingDate" label="lots.openingDate" style={{ flex: 1 }} />
                    <OutputBox name="barcode" label="lots.barcode" style={{ flex: 1 }} />
                  </Horizontal>
                  <Horizontal style={{ backgroundColor: '#f8fcfd' }}>
                    <OutputBox name="mail" label="lots.mail" style={{ flex: 2 }} />
                    <OutputBoxContent label="lots.status.name" style={{ flex: 1 }}>
                      <LocalizedOutputValue name="status" prefix="lots.status" />
                    </OutputBoxContent>
                    <OutputBox name="building" label="lots.building" style={{ flex: 2 }} />
                    <OutputBoxContent label="lots.msds" style={{ flex: 1 }}>
                      <OutputLink name="msds" />
                    </OutputBoxContent>
                    <OutputBoxDate name="checkInDate" label="lots.checkInDate" style={{ flex: 2 }} />
                  </Horizontal>
                </CollapsibleRowList>;

  return (
    <List title={TITLE}
      entityName={ENTITY_NAME}
      entityRoute={ENTITY_NAME}
      component={table}
      filters={defaultFilters()}
      hideAddButton = {!withRoles(['A', 'E'])}
    />
  );
};

const Lots = props => {
  const basePath = '/' + ENTITY_NAME;
  return (
    <MainContainer>
      <Switch>
        <Route exact path={basePath} component={CrudList} />
        <Route exact path={basePath + '/edit/:number'} render={props => <CrudEdit {...props} />} />
        <Route exact path={basePath + '/add'} render={props => <CrudEdit {...props} />} />
      </Switch>
    </MainContainer>
  );
};

export default Lots;



// WEBPACK FOOTER //
// ./src/main/pages/registry/Lots.js